import React from 'react';
export const IlluminatedPlant = () => (
  <svg width="206px" height="160px" viewBox="0 0 206 160" version="1.1">
    <defs>
      <polygon
        id="path-1"
        points="0.137 49.452 63.996 49.645 69.677 12.191 57.442 0.747"
      />
      <linearGradient
        x1="79.8791369%"
        y1="25.8708718%"
        x2="55.7265956%"
        y2="78.4449409%"
        id="linearGradient-3"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#F2F4F6" offset="100%" />
      </linearGradient>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-223.000000, -988.000000)">
        <g transform="translate(224.000000, 988.000000)">
          <path
            d="M152.569827,153.828286 L56.4303682,153.828286 L4.50857005,101.847549 C3.83047665,101.168692 3.83047665,100.057914 4.50857005,99.3790569 L103.267034,0.508488428 C103.945999,-0.169496143 105.054655,-0.169496143 105.732749,0.508488428 L204.492084,99.3790569 C205.169305,100.057914 205.169305,101.168692 204.492084,101.847549 L152.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <g transform="translate(5.000000, 13.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.1826 34.0658 0.1826 0.1068 13.7806 0.1068"
            />
            <polyline
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.1826 34.0658 0.1826 0.1068 13.7806 0.1068"
            />
          </g>
          <g transform="translate(5.000000, 13.710000)">
            <polyline
              fill="#FFFFFF"
              points="32.7315 0.1068 76.5365 0.1068 76.5365 98.7948 0.1825 98.7948 0.1825 64.2648"
            />
            <polyline
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="32.7315 0.1068 76.5365 0.1068 76.5365 98.7948 0.1825 98.7948 0.1825 64.2648"
            />
          </g>
          <polygon
            fill="#E4E6EA"
            points="13.226 65.472 73.889 65.472 73.889 22.117 13.226 22.117"
          />
          <polygon
            fill="#E4E6EA"
            points="13.226 99.702 73.889 99.702 73.889 74.384 13.226 74.384"
          />
          <polygon
            fill="#FFFFFF"
            points="0.224 116.298 85.707 116.298 85.707 108.067 0.224 108.067"
          />
          <polygon
            stroke="#DCE4E7"
            points="0.224 116.298 85.707 116.298 85.707 108.067 0.224 108.067"
          />
          <g transform="translate(78.000000, 75.710000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <g />
            <polygon
              fill="url(#linearGradient-3)"
              mask="url(#mask-2)"
              points="0.137 49.452 63.996 49.645 69.677 12.191 57.442 0.747"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="0.224 13.817 85.707 13.817 85.707 5.587 0.224 5.587"
          />
          <polygon
            stroke="#DCE4E7"
            points="0.224 13.817 85.707 13.817 85.707 5.587 0.224 5.587"
          />
          <path
            d="M131.0713,155.1205 C131.0713,157.4305 124.6913,159.3025 116.8203,159.3025 C108.9493,159.3025 102.5693,157.4305 102.5693,155.1205 C102.5693,152.8105 108.9493,150.9375 116.8203,150.9375 C124.6913,150.9375 131.0713,152.8105 131.0713,155.1205"
            fill="#D0D7DA"
          />
          <g transform="translate(109.000000, 117.710000)">
            <path
              d="M2.2666,0.5687 C1.3406,0.8507 0.0076,4.0857 0.7426,6.5047 C1.4776,8.9227 3.4846,10.6237 5.1666,10.1117 C6.8496,9.5997 7.5706,7.0707 6.8346,4.6527 C6.0996,2.2337 3.1926,0.2877 2.2666,0.5687"
              fill="#5EDAB0"
            />
            <path
              d="M2.2666,0.5687 C1.3406,0.8507 0.0076,4.0857 0.7426,6.5047 C1.4776,8.9227 3.4846,10.6237 5.1666,10.1117 C6.8496,9.5997 7.5706,7.0707 6.8346,4.6527 C6.0996,2.2337 3.1926,0.2877 2.2666,0.5687"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(117.000000, 117.710000)">
            <path
              d="M5.2637,0.5687 C6.1897,0.8507 7.5227,4.0857 6.7877,6.5047 C6.0527,8.9227 4.0457,10.6237 2.3637,10.1117 C0.6807,9.5997 -0.0403,7.0707 0.6957,4.6527 C1.4307,2.2337 4.3377,0.2877 5.2637,0.5687"
              fill="#5EDAB0"
            />
            <path
              d="M5.2637,0.5687 C6.1897,0.8507 7.5227,4.0857 6.7877,6.5047 C6.0527,8.9227 4.0457,10.6237 2.3637,10.1117 C0.6807,9.5997 -0.0403,7.0707 0.6957,4.6527 C1.4307,2.2337 4.3377,0.2877 5.2637,0.5687"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(105.000000, 121.710000)">
            <path
              d="M0.6143,0.5599 C-0.0167,1.2929 0.5913,4.7389 2.5073,6.3869 C4.4233,8.0359 7.0293,8.3969 8.1753,7.0639 C9.3223,5.7309 8.5753,3.2079 6.6593,1.5599 C4.7433,-0.0881 1.2453,-0.1741 0.6143,0.5599"
              fill="#008660"
            />
            <path
              d="M0.6143,0.5599 C-0.0167,1.2929 0.5913,4.7389 2.5073,6.3869 C4.4233,8.0359 7.0293,8.3969 8.1753,7.0639 C9.3223,5.7309 8.5753,3.2079 6.6593,1.5599 C4.7433,-0.0881 1.2453,-0.1741 0.6143,0.5599"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(119.000000, 121.710000)">
            <path
              d="M8.7002,0.5599 C9.3312,1.2929 8.7232,4.7389 6.8072,6.3869 C4.8902,8.0359 2.2852,8.3969 1.1382,7.0639 C-0.0078,5.7309 0.7382,3.2079 2.6552,1.5599 C4.5712,-0.0881 8.0692,-0.1741 8.7002,0.5599"
              fill="#008660"
            />
            <path
              d="M8.7002,0.5599 C9.3312,1.2929 8.7232,4.7389 6.8072,6.3869 C4.8902,8.0359 2.2852,8.3969 1.1382,7.0639 C-0.0078,5.7309 0.7382,3.2079 2.6552,1.5599 C4.5712,-0.0881 8.0692,-0.1741 8.7002,0.5599"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(113.000000, 118.710000)">
            <path
              d="M3.4776,0.7904 C2.5116,0.8524 0.4766,3.6984 0.6406,6.2214 C0.8046,8.7434 2.3716,10.8564 4.1256,10.7424 C5.8806,10.6284 7.1596,8.3304 6.9946,5.8084 C6.8306,3.2854 4.4436,0.7274 3.4776,0.7904"
              fill="#008660"
            />
            <path
              d="M3.4776,0.7904 C2.5116,0.8524 0.4766,3.6984 0.6406,6.2214 C0.8046,8.7434 2.3716,10.8564 4.1256,10.7424 C5.8806,10.6284 7.1596,8.3304 6.9946,5.8084 C6.8306,3.2854 4.4436,0.7274 3.4776,0.7904"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="131.6997 153.0004 101.0127 153.0004 97.1747 128.0744 135.5377 128.0744"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="131.6997 153.0004 101.0127 153.0004 97.1747 128.0744 135.5377 128.0744"
          />
          <path
            d="M121.6485,130.9086 L98.9645,130.9086"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#F2F3F3"
            points="129.0616 150.5785 122.8886 150.5785 125.6316 133.0255 132.4146 133.0255"
          />
          <path
            d="M132.8565,130.9086 L124.0045,130.9086"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.7525,153.9379 L18.7165,153.9379"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M112.8262,97.5815 L112.8262,98.8965"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M112.8262,101.5277 L112.8262,102.8437"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M115.4571,100.2123 L114.1421,100.2123"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M111.5103,100.2123 L110.1953,100.2123"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M138.1909,102.8442 C138.1909,103.3262 137.7999,103.7172 137.3169,103.7172 C136.8349,103.7172 136.4429,103.3262 136.4429,102.8442 C136.4429,102.3612 136.8349,101.9702 137.3169,101.9702 C137.7999,101.9702 138.1909,102.3612 138.1909,102.8442"
            fill="#0B9CE5"
          />
          <path
            d="M99.7959,111.8695 C99.7959,112.3515 99.4049,112.7435 98.9219,112.7435 C98.4399,112.7435 98.0479,112.3515 98.0479,111.8695 C98.0479,111.3875 98.4399,110.9955 98.9219,110.9955 C99.4049,110.9955 99.7959,111.3875 99.7959,111.8695"
            fill="#AA81F7"
          />
          <path
            d="M56.3028,57.6928 C56.3028,58.3568 55.7648,58.8948 55.1008,58.8948 C54.4368,58.8948 53.8988,58.3568 53.8988,57.6928 C53.8988,57.0288 54.4368,56.4908 55.1008,56.4908 C55.7648,56.4908 56.3028,57.0288 56.3028,57.6928"
            fill="#FFFFFF"
          />
          <path
            d="M56.3028,57.6928 C56.3028,58.3568 55.7648,58.8948 55.1008,58.8948 C54.4368,58.8948 53.8988,58.3568 53.8988,57.6928 C53.8988,57.0288 54.4368,56.4908 55.1008,56.4908 C55.7648,56.4908 56.3028,57.0288 56.3028,57.6928 Z"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.4117,88.7445 C26.4117,89.4085 25.8737,89.9465 25.2097,89.9465 C24.5457,89.9465 24.0077,89.4085 24.0077,88.7445 C24.0077,88.0805 24.5457,87.5425 25.2097,87.5425 C25.8737,87.5425 26.4117,88.0805 26.4117,88.7445"
            fill="#FFFFFF"
          />
          <path
            d="M26.4117,88.7445 C26.4117,89.4085 25.8737,89.9465 25.2097,89.9465 C24.5457,89.9465 24.0077,89.4085 24.0077,88.7445 C24.0077,88.0805 24.5457,87.5425 25.2097,87.5425 C25.8737,87.5425 26.4117,88.0805 26.4117,88.7445 Z"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M64.1763,40.1772 C64.1763,40.8412 63.6383,41.3792 62.9743,41.3792 C62.3103,41.3792 61.7723,40.8412 61.7723,40.1772 C61.7723,39.5142 62.3103,38.9752 62.9743,38.9752 C63.6383,38.9752 64.1763,39.5142 64.1763,40.1772"
            fill="#FFFFFF"
          />
          <path
            d="M64.1763,40.1772 C64.1763,40.8412 63.6383,41.3792 62.9743,41.3792 C62.3103,41.3792 61.7723,40.8412 61.7723,40.1772 C61.7723,39.5142 62.3103,38.9752 62.9743,38.9752 C63.6383,38.9752 64.1763,39.5142 64.1763,40.1772 Z"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.2095,58.8949 C25.2095,59.5589 24.6715,60.0969 24.0075,60.0969 C23.3435,60.0969 22.8055,59.5589 22.8055,58.8949 C22.8055,58.2309 23.3435,57.6929 24.0075,57.6929 C24.6715,57.6929 25.2095,58.2309 25.2095,58.8949"
            fill="#FFFFFF"
          />
          <path
            d="M25.2095,58.8949 C25.2095,59.5589 24.6715,60.0969 24.0075,60.0969 C23.3435,60.0969 22.8055,59.5589 22.8055,58.8949 C22.8055,58.2309 23.3435,57.6929 24.0075,57.6929 C24.6715,57.6929 25.2095,58.2309 25.2095,58.8949 Z"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.9624,93.0307 C45.9624,93.6947 45.4234,94.2327 44.7594,94.2327 C44.0964,94.2327 43.5574,93.6947 43.5574,93.0307 C43.5574,92.3667 44.0964,91.8287 44.7594,91.8287 C45.4234,91.8287 45.9624,92.3667 45.9624,93.0307"
            fill="#FFFFFF"
          />
          <path
            d="M45.9624,93.0307 C45.9624,93.6947 45.4234,94.2327 44.7594,94.2327 C44.0964,94.2327 43.5574,93.6947 43.5574,93.0307 C43.5574,92.3667 44.0964,91.8287 44.7594,91.8287 C45.4234,91.8287 45.9624,92.3667 45.9624,93.0307 Z"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.9742,80.7367 C62.9742,81.4007 62.4362,81.9387 61.7722,81.9387 C61.1082,81.9387 60.5702,81.4007 60.5702,80.7367 C60.5702,80.0727 61.1082,79.5347 61.7722,79.5347 C62.4362,79.5347 62.9742,80.0727 62.9742,80.7367"
            fill="#FFFFFF"
          />
          <path
            d="M62.9742,80.7367 C62.9742,81.4007 62.4362,81.9387 61.7722,81.9387 C61.1082,81.9387 60.5702,81.4007 60.5702,80.7367 C60.5702,80.0727 61.1082,79.5347 61.7722,79.5347 C62.4362,79.5347 62.9742,80.0727 62.9742,80.7367 Z"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M140.8169,112.7983 L140.8169,114.5483"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M140.8169,118.0483 L140.8169,119.7983"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M144.3169,116.2983 L142.5669,116.2983"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M139.0669,116.2983 L137.3169,116.2983"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <polyline
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="72.3872 75.3832 13.5212 75.3832 13.5212 99.7012"
          />
          <polyline
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="73.5127 22.1166 13.9707 22.1166 13.9707 58.2386"
          />
          <path
            d="M28.1914,40.3442 C27.9814,38.0062 29.1444,35.8652 31.0104,34.7032 C30.2844,34.5222 29.5184,34.4482 28.7314,34.5202 C24.9614,34.8582 22.1804,38.1872 22.5184,41.9562 C22.8564,45.7252 26.1864,48.5072 29.9554,48.1682 C31.8084,48.0022 33.4194,47.1112 34.5414,45.8022 C31.3074,45.9982 28.4834,43.5932 28.1914,40.3442"
            fill="#FFFFFF"
          />
          <path
            d="M28.1914,40.3442 C27.9814,38.0062 29.1444,35.8652 31.0104,34.7032 C30.2844,34.5222 29.5184,34.4482 28.7314,34.5202 C24.9614,34.8582 22.1804,38.1872 22.5184,41.9562 C22.8564,45.7252 26.1864,48.5072 29.9554,48.1682 C31.8084,48.0022 33.4194,47.1112 34.5414,45.8022 C31.3074,45.9982 28.4834,43.5932 28.1914,40.3442 Z"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#F3F4F6"
            points="86.2002 107.5951 86.2002 116.5091 3.2232 116.5091 8.2232 121.4831 88.7072 121.4831 88.7072 118.4031 88.7072 116.5091 88.7072 110.1011"
          />
          <path
            d="M86.1724,68.8539 C86.1724,69.6919 85.4934,70.3719 84.6544,70.3719 C83.8164,70.3719 83.1364,69.6919 83.1364,68.8539 C83.1364,68.0149 83.8164,67.3349 84.6544,67.3349 C85.4934,67.3349 86.1724,68.0149 86.1724,68.8539"
            fill="#DCE4E7"
          />
          <g transform="translate(84.000000, 13.710000)">
            <path d="M0.6548,0.1068 L0.6548,53.6258" fill="#FFFFFF" />
            <path d="M0.6548,0.1068 L0.6548,53.6258" stroke="#DCE4E7" />
          </g>
          <polygon
            fill="#F3F4F6"
            points="5.182 35.378 81.536 35.378 81.536 13.816 5.182 13.816"
          />
          <polygon
            stroke="#DCE4E7"
            points="5.182 35.378 81.536 35.378 81.536 13.816 5.182 13.816"
          />
          <g transform="translate(63.000000, 24.710000)">
            <path d="M0.8003,0.5951 L10.5123,0.5951" fill="#FFFFFF" />
            <path d="M0.8003,0.5951 L10.5123,0.5951" stroke="#DCE4E7" />
          </g>
          <g transform="translate(13.000000, 24.710000)">
            <path d="M0.9707,0.5951 L42.9197,0.5951" fill="#FFFFFF" />
            <path d="M0.9707,0.5951 L42.9197,0.5951" stroke="#DCE4E7" />
          </g>
          <polygon
            fill="#FFFFFF"
            points="189.606 100.3949 186.148 103.7199 153.138 69.3889 156.597 66.0639"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="189.606 100.3949 186.148 103.7199 153.138 69.3889 156.597 66.0639"
          />
          <polygon
            fill="#FFFFFF"
            points="171.6983 144.7143 167.3043 142.7863 186.3443 99.3753 190.7383 101.3023"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="171.6983 144.7143 167.3043 142.7863 186.3443 99.3753 190.7383 101.3023"
          />
          <path
            d="M154.7993,76.0795 L145.7273,68.0645 C150.1933,63.0105 153.8143,58.9125 158.3493,62.9195 C162.8853,66.9275 159.2653,71.0245 154.7993,76.0795"
            fill="#FFFFFF"
          />
          <path
            d="M154.7993,76.0795 L145.7273,68.0645 C150.1933,63.0105 153.8143,58.9125 158.3493,62.9195 C162.8853,66.9275 159.2653,71.0245 154.7993,76.0795 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(129.000000, 65.710000)">
            <path
              d="M10.7896,0.3226 C15.1176,-0.1564 19.6246,1.1226 23.1446,4.2326 C29.7646,10.0806 30.3896,20.1866 24.5416,26.8056 L0.5716,5.6296 C1.7136,4.3366 3.0176,3.2716 4.4266,2.4396"
              fill="#FFFFFF"
            />
            <path
              d="M10.7896,0.3226 C15.1176,-0.1564 19.6246,1.1226 23.1446,4.2326 C29.7646,10.0806 30.3896,20.1866 24.5416,26.8056 L0.5716,5.6296 C1.7136,4.3366 3.0176,3.2716 4.4266,2.4396"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M191.0459,102.807 C191.0459,105.13 189.1629,107.013 186.8389,107.013 C184.5159,107.013 182.6329,105.13 182.6329,102.807 C182.6329,100.484 184.5159,98.6 186.8389,98.6 C189.1629,98.6 191.0459,100.484 191.0459,102.807"
            fill="#FFFFFF"
          />
          <path
            d="M191.0459,102.807 C191.0459,105.13 189.1629,107.013 186.8389,107.013 C184.5159,107.013 182.6329,105.13 182.6329,102.807 C182.6329,100.484 184.5159,98.6 186.8389,98.6 C189.1629,98.6 191.0459,100.484 191.0459,102.807 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M184.9141,147.6235 L155.8511,147.6235 C154.7511,147.6235 153.8511,146.7235 153.8511,145.6235 L153.8511,144.2455 C153.8511,143.1445 154.7511,142.2455 155.8511,142.2455 L184.9141,142.2455 C186.0141,142.2455 186.9141,143.1445 186.9141,144.2455 L186.9141,145.6235 C186.9141,146.7235 186.0141,147.6235 184.9141,147.6235"
            fill="#FFFFFF"
          />
          <path
            d="M184.9141,147.6235 L155.8511,147.6235 C154.7511,147.6235 153.8511,146.7235 153.8511,145.6235 L153.8511,144.2455 C153.8511,143.1445 154.7511,142.2455 155.8511,142.2455 L184.9141,142.2455 C186.0141,142.2455 186.9141,143.1445 186.9141,144.2455 L186.9141,145.6235 C186.9141,146.7235 186.0141,147.6235 184.9141,147.6235 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M189.8594,153.0004 L151.5214,153.0004 C150.4214,153.0004 149.5214,152.1014 149.5214,151.0004 L149.5214,149.6234 C149.5214,148.5224 150.4214,147.6234 151.5214,147.6234 L189.8594,147.6234 C190.9594,147.6234 191.8594,148.5224 191.8594,149.6234 L191.8594,151.0004 C191.8594,152.1014 190.9594,153.0004 189.8594,153.0004"
            fill="#FFFFFF"
          />
          <path
            d="M189.8594,153.0004 L151.5214,153.0004 C150.4214,153.0004 149.5214,152.1014 149.5214,151.0004 L149.5214,149.6234 C149.5214,148.5224 150.4214,147.6234 151.5214,147.6234 L189.8594,147.6234 C190.9594,147.6234 191.8594,148.5224 191.8594,149.6234 L191.8594,151.0004 C191.8594,152.1014 190.9594,153.0004 189.8594,153.0004 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="70.362 153.838 79.891 153.838 79.891 124.442 70.362 124.442"
          />
          <polygon
            stroke="#C5CED1"
            points="70.362 153.838 79.891 153.838 79.891 124.442 70.362 124.442"
          />
          <polygon
            fill="#FFFFFF"
            points="55.646 153.838 70.297 153.838 70.297 113.946 55.646 113.946"
          />
          <polygon
            stroke="#C5CED1"
            points="55.646 153.838 70.297 153.838 70.297 113.946 55.646 113.946"
          />
          <polygon
            fill="#FFFFFF"
            points="48.321 153.838 55.646 153.838 55.646 118.688 48.321 118.688"
          />
          <polygon
            stroke="#C5CED1"
            points="48.321 153.838 55.646 153.838 55.646 118.688 48.321 118.688"
          />
          <path
            d="M56.6997,122.8656 L69.1967,122.8656"
            stroke="#E2E8EE"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.4292,128.2846 L78.7362,128.2846"
            stroke="#E2E8EE"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M56.6997,149.8149 L69.1967,149.8149"
            stroke="#E2E8EE"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#E2E8EE"
            points="70.859 150.798 79.225 150.798 79.225 135.57 70.859 135.57"
          />
          <polygon
            fill="#E2E8EE"
            points="56.303 120.533 69.646 120.533 69.646 116.83 56.303 116.83"
          />
          <polygon
            fill="#E2E8EE"
            points="48.975 129.134 55.099 129.134 55.099 125.431 48.975 125.431"
          />
          <path
            d="M86.5088,153.9379 L36.7528,153.9379"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(159.000000, 138.710000)">
            <path d="M0.4292,0.7816 L0.4292,2.9836" fill="#FFFFFF" />
            <path
              d="M0.4292,0.7816 L0.4292,2.9836"
              stroke="#AA81F7"
              strokeWidth="4"
            />
          </g>
          <path
            d="M146.065,83.3998 L154.045,74.0368 C154.045,74.0368 156.459,79.4468 155.958,82.9868 C155.457,86.5258 153.302,89.3868 153.302,89.3868 L146.065,83.3998 Z"
            fill="#F3F4F6"
          />
          <path
            d="M188.4639,102.807 C188.4639,103.703 187.7359,104.431 186.8389,104.431 C185.9419,104.431 185.2149,103.703 185.2149,102.807 C185.2149,101.91 185.9419,101.182 186.8389,101.182 C187.7359,101.182 188.4639,101.91 188.4639,102.807"
            fill="#F5C400"
          />
          <g transform="translate(160.000000, 73.710000)">
            <path d="M0.6397,0.1605 L14.9067,14.9735" fill="#FFFFFF" />
            <path
              d="M0.6397,0.1605 L14.9067,14.9735"
              stroke="#E2E8EE"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(170.000000, 107.710000)">
            <path d="M14.96,0.7679 L0.69,33.1669" fill="#FFFFFF" />
            <path
              d="M14.96,0.7679 L0.69,33.1669"
              stroke="#E2E8EE"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(180.000000, 93.710000)">
            <path d="M0.4151,0.7396 L3.2491,3.5736" fill="#FFFFFF" />
            <path
              d="M0.4151,0.7396 L3.2491,3.5736"
              stroke="#E2E8EE"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
